<template>
	<section class="shops p-0">
		<div v-if="screenWidth > 1024" class="content">
			<div
				v-for="(ts, index) in topShops" :key="index"
				class="col-6 pr-2 pl-2 col-lg-3 mobile float-right mb-4"
			>
				<router-link
					class="item"
					:to="{
						name: 'shop',
						params: {
							id: ts.shopId,
							name: ts.name.replace(/ /gi, '-')
						}
					}"
				>
					<div class="details">
						<label>{{ ts.name }}</label>
						<small
							v-if="ts.shopWagePercent"
							title="کارمزد ماهیانه"
							class="float-left"
							>{{ ts.shopWagePercent }}%</small
						>
					</div>
					<div class="inner">
						<div
							class="img"
							v-bind:style="{
								'background-image':
									'url(' + rootImagePath + ts.imagePath + ')'
							}"
						></div>
					</div>
					<div class="score-comment">
						<div class="star-rating float-left">
							<font-awesome-icon
								:icon="ts.scoreAverage >= 5 ? ['fa', 'star']: ['far', 'star']"
								color="yellow"
							/>
							<font-awesome-icon
								:icon="ts.scoreAverage >= 4 ? ['fa', 'star']: ['far', 'star']"
								color="yellow"
							/>
							<font-awesome-icon
								:icon="ts.scoreAverage >= 3 ? ['fa', 'star']: ['far', 'star']"
								color="yellow"
							/>
							<font-awesome-icon
								:icon="ts.scoreAverage >= 2 ? ['fa', 'star'] : ['far', 'star']"
								color="yellow"
							/>
							<font-awesome-icon
								:icon="ts.scoreAverage >= 1 ? ['fa', 'star'] : ['far', 'star']"
								color="yellow"
							/>
						</div>
						<div class="comments float-right" style="color:#000;">
							<font-awesome-icon
								:icon="['far', 'comment']"
								color="black"
							/>
							<b-badge class="shop-comment-badge">{{
								ts.commentsCount || 0
							}}</b-badge>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<swiper
			:options="swiperOption"
			v-if="screenWidth <= 1024"
			class="content"
		>
			<swiper-slide
				v-for="(ts, index) in topShops"
				:key="index"
				class="col-6 pr-2 pl-2 col-lg-3 mobile float-right"
			>
				<router-link
					class="item"
					:to="{
						name: 'shop',
						params: {
							id: ts.shopId,
							name: ts.name.replace(/ /gi, '-')
						}
					}"
				>
					<div class="details">
						<label>{{ ts.name }}</label>
						<small
							v-if="ts.shopWagePercent"
							title="کارمزد ماهیانه"
							class="float-left"
							>{{ ts.shopWagePercent }}%</small
						>
					</div>
					<div class="inner">
						<div
							class="img"
							v-bind:style="{
								'background-image':
									'url(' + rootImagePath + ts.imagePath + ')'
							}"
						></div>
					</div>
				</router-link>
			</swiper-slide>
		</swiper>

		<div class="col-12 float-left text-center mt-3 mb-2">
			<router-link class="link-more text-dark" :to="{ name: 'shops' }"
				>مشاهده همه فروشگاه ها</router-link
			>
		</div>
	</section>
</template>
<script>
export default {
	props: {
		rootImagePath: {
			type: String
		},

		topShops: {
			type: Array
		}
	},

	beforeMount() {
		this.screenWidth = window.outerWidth;
	},

	data() {
		return {
			screenWidth: 0,
			swiperOption: {
				loop: true,
				slidesPerView: "auto",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				}
			}
		};
	}
};
</script>
<style scoped>
.shops {
	width: 100%;
	float: right;
	text-align: center;
	background-color: #eaeded;
}

.shops .content {
	width: 100%;
	float: right;
}

.shops .content .item {
	transition: all 0.5s;
	width: 100%;
	height: 370px;
	display: inline-block;
	padding: 10px;
	background: #fff;
}

.shops .content .item .inner {
	width: 100%;
	height: 300px;
	float: right;
	position: relative;
}

.shops .content .item .img {
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	width: 100%;
	height: 290px;
}

.shops .content .item .img.tiny {
	height: 100px;
}

.shops .content .item .details {
	width: 100%;
	color: #000;
	text-align: right;
	font-weight: bold;
	font-size: 16px;
}

@media (max-width: 1024px) {
	.shops .content .item {
		height: 230px;
		padding: 5px;
	}

	.shops .content .item .details {
		font-size: 14px;
	}

	.shops .content .item .inner,
	.shops .content .item .img {
		height: 190px;
	}

	.shops .content .item .img.tiny {
		height: 63px;
	}

	.row {
		margin: 0;
	}
}

.z-10 {
	z-index: 10;
}
</style>
